export default "__VITE_ASSET__BSUlvqN___"